import cx from 'classnames';

const __DEV__ = process.env['NODE_ENV'] !== 'production';

interface CallBack<Params extends unknown[]> {
  (...args: Params): void;
}

const callAll =
  <Params extends unknown[]>(...fns: Array<CallBack<Params> | undefined>) =>
  (...args: Params) =>
    fns.forEach((fn) => typeof fn === 'function' && fn(...args));

const externalUrl = ({src}: {src: string}) => src;


export { cx, __DEV__, callAll, externalUrl };
